import { render, staticRenderFns } from "./CustomerLocation.vue?vue&type=template&id=45bc6568&scoped=true"
import script from "./CustomerLocation.vue?vue&type=script&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&lang=js"
import style0 from "./CustomerLocation.vue?vue&type=style&index=0&id=45bc6568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc6568",
  null
  
)

export default component.exports